const recordLinkVisited = (element: HTMLLinkElement, link_id: string, order_item_id: string, order_id: string, email: string, event: Event) => {
  event.preventDefault()
  fetch('/apps/downloads/visits/' + link_id, {
    method: 'post',
    body: JSON.stringify({ order_item_id: order_item_id, order_id: order_id, email: email }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (response.ok) {
        return response.json()
      } else {
        throw new Error('Failed to track click')
      }
    })
    .then((data) => {
      if (data.url) window.open(data.url, '_self')
      else {
        const span = document.createElement('span')
        span.classList.add('sky-pilot-link-error')
        span.textContent = data.error
        element.parentNode?.replaceChild(span, element)
      }
    })
    .catch((error) => {
      console.error('Error tracking click:', error)
    })
}

export const initializeLink = (element: HTMLLinkElement) => {
  const link_id = element.getAttribute('data-link-id')
  const order_item_id = element.getAttribute('data-item-id')
  const order_id = element.getAttribute('data-order-id')
  const email = element.getAttribute('data-customer-email')
  if (link_id && order_id && order_item_id && email) {
    element.addEventListener('click', function (event: Event) {
      recordLinkVisited(element, link_id, order_item_id, order_id, email, event)
    })
  }
}

export const initializeLinks = (parent?: HTMLElement) => {
  const scope = parent || document

  scope.querySelectorAll<HTMLLinkElement>('a.sky-pilot-link').forEach((el) => {
    initializeLink(el)
  })
}
